import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ProfileService } from '../profile.service';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { of } from 'rxjs/internal/observable/of';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upgrade-premium',
  templateUrl: './upgrade-premium.component.html',
  styleUrls: ['./upgrade-premium.component.scss']
})
export class UpgradePremiumComponent implements OnInit {

  user;
  premium;

  constructor(
    private profileService: ProfileService,
    public matDialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.profileService.getDetailPremiumShop().pipe(
      map(res => {
        // // console.log(res);
        this.user = res.result
        // // console.log(this.user);
      }),
      switchMap(res => {
        return this.profileService.getProfile().pipe(
          map(res => {
            // // console.log(res);
            this.premium = res.result;
            // // console.log(this.premium.IS_PREMIUM);
          })
        )
      })
    ).subscribe();

  }

  upgrade() {
    // let balance = Math.floor(this.user.TOKEN_AVALABLE) - Math.floor(this.user.DETAIL_EXCHANG.TOKEN_REQ);
    let balance = this.user.TOKEN_AVALABLE - this.user.DETAIL_EXCHANG.TOKEN_REQ;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'อัพเกรดสถานะสมาชิก',
      description: `<p class="text-primary">คุณต้องการอัพเกรดสถานะเป็น <span class="text-danger">Premium</span> ใช่ไหม?</p>
                      <p>ใช้ Coin : ${this.user.DETAIL_EXCHANG.TOKEN_REQ}</p>
                      <p>วันเริ่มใช้สถานะ : ${new DatePipe().transform(this.user.DETAIL_EXCHANG.START_PREMIUM.toString(), 'full')}</p>
                      <p>วันสิ้นสุดสถานะ : ${new DatePipe().transform(this.user.DETAIL_EXCHANG.EXPIREDATE.toString(), 'full')} </p>`,
      actionBtnText: 'อัพเกรด',
      cancleBtnText: 'ย้อนกลับ',
      isConfirm: true
    }

    const formDialog = this.matDialog.open(ModalComponent, dialogConfig);

    formDialog.afterClosed().pipe(

      switchMap(isConfirm => {
        if (isConfirm) {
          return this.profileService.upgradePremium().pipe(
            switchMap(upgrade => {
              if (upgrade) {
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '350px';
                dialogConfig.data = {
                  title: 'อัพเกรดพรีเมี่ยมสำเร็จ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                <p class="title text-center">อัพเกรดสถานะ <span class="text-danger">premium </span>สำเร็จ</p>
                                <p class="title text-center">วันสิ้นสุดสถานะ: ${new DatePipe().transform(this.user.DETAIL_EXCHANG.EXPIREDATE.toString(), 'full')}</p>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B'
                }
              }

              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed().pipe(
                map(upgrade => {
                  if (!upgrade) {
                    this.router.navigate(['/profile']);

                  }
                })
              )
            })
          )
        } else {
          return of(null)
        }
      })
    ).subscribe();
  }

}
